import { render, staticRenderFns } from "./TicketOverview.vue?vue&type=template&id=6d8f7e8c"
import script from "./TicketOverview.vue?vue&type=script&lang=ts"
export * from "./TicketOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports